// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'person-connection';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M8.95 10.091a3.193 3.193 0 0 0-6.02.047m2.984-3.05a1.95 1.95 0 1 0 0-3.9 1.95 1.95 0 0 0 0 3.9z' />
    <path d='M5.906 11.063a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5zM15.094 15a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5zM8.36 17.438a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2zm1.919-8.72 2.881 2.88m-3.824 4.231 3.704-2.16' />
  </g>
);

export const viewBox = '0 0 18 18';
